import { Box, Button, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	gradientFrom: string;
	onClick: () => void;
};

export const DashboardCardDetailButton: FC<Props> = ({
	gradientFrom,
	onClick,
}) => {
	const { t } = useResource();
	const { spacingTokens } = useTheme();

	return (
		<Box mt={spacingTokens.sm}>
			<Button
				variant="onGradient"
				sx={{ color: gradientFrom }}
				onClick={onClick}
			>
				{t(Resources.Dashboard.TitleCard.title)}
			</Button>
		</Box>
	);
};
